export default "__VITE_ASSET__DrrEReyT__"